import React, {ReactElement} from 'react';
import {useTheme} from 'styled-components';
import {ForecastTheme} from '@forecast-it/design-system';
import {SageLogo} from '../../../../images/SageLogo';
import {ForecastLogo} from '../../../../images/ForecastLogo';

export enum LOGO_SIZE {
	SMALL,
	MEDIUM,
}

const getLogoDimensions = (size: LOGO_SIZE, theme = ForecastTheme.Sky) => {
	const logoDimensions = {
		[ForecastTheme.Sky]: {
			[LOGO_SIZE.SMALL]: {
				width: '81',
				height: '14',
			},
			[LOGO_SIZE.MEDIUM]: {
				width: '120',
				height: '20',
			},
		},
		[ForecastTheme.Sage]: {
			[LOGO_SIZE.SMALL]: {
				width: '50',
				height: '28',
			},
			[LOGO_SIZE.MEDIUM]: {
				width: '142',
				height: '80',
			},
		},
	};
	return logoDimensions[theme][size];
};

interface LogoProps {
	size: LOGO_SIZE;
}

const Logo = ({size = LOGO_SIZE.SMALL}: LogoProps): ReactElement => {
	const theme = useTheme();
	const logoDimensions = getLogoDimensions(size, theme.themeName);
	switch (theme.themeName) {
		case ForecastTheme.Sage:
			return <SageLogo {...logoDimensions} />;
		default:
			return <ForecastLogo {...logoDimensions} />;
	}
};

export default Logo;
